<template>
    <div v-if="isVisible" class="popup-overlay" @click="closePopup">
        <div class="popup-content" @click.stop>
            <button class="close-btn" @click="closePopup"><img src='@/assets/images/cross.png' /></button>
            <div class="header-popup">
                <div class="title-code">
                    <template v-if="promotion.status!='deleted'">{{promotion.code}}</template>
                    <template v-else>{{ promoCodeLight(promotion.code) }}</template>
                    <div @click="copyCode" class="cc"  v-if="promotion.status!='deleted'">
                        <img v-if="copied==false" src='@/assets/images/copy.svg' />
                        <img v-else class="copied" src='@/assets/images/ok.svg' />
                    </div>
                </div>
                <div class="green-patch">-{{promotion.amount}}%</div>

            </div>
            <table class="table left-align">
                <tr>
                    <th v-if="language=='fr'">Produit concerné</th>
                    <th v-else>Concerned model(s)</th>
                    <td><span v-for="product,index in promotion.products" :key="product.id">{{ product.name }}<span v-if="index<promotion.products.length-1">, </span></span></td>
                </tr>
               
                <tr>
                    <th v-if="language=='fr'">Limite d’utilisation par client</th>
                    <th v-else>Usage limit per client</th>
                    <td> 
                        <span v-if="promotion.user_limit"> {{ promotion.user_limit }}</span>
                        <span v-else>
                            <template v-if="language=='fr'">Illimité</template>
                            <template v-else>Unlimited</template>
                        </span>
                     </td>
                </tr>
                <tr>
                    <th v-if="language=='fr'">Total d’utilisations enregistrées</th>
                    <th v-else>Total usages</th>
                    <td>{{ promotion.use_count }}</td>
                </tr>
                <tr>
                    <th v-if="language=='fr'">Date de début</th>
                    <th v-else>Begin date</th>
                    <td>
                        <span v-if="promotion.begin_date"> {{ promotion.begin_date }}</span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr>
                    <th v-if="language=='fr'">Date de fin</th>
                    <th v-else>End date</th>
                    <td>
                        <span v-if="promotion.end_date"> {{ promotion.end_date }}</span>
                        <span v-else>-</span>
                       
                    </td>
                </tr>
                <tr>
                    <th v-if="language=='fr'">Plafond total d’utilisations</th>
                    <th v-else>Plafond total d’utilisations</th>
                    <td>
                        <span v-if="promotion.usage_limit"> {{ promotion.usage_limit }}</span>
                        <span v-else> 
                            <template v-if="language=='fr'">Illimité</template>
                            <template v-else>Unlimited</template>
                        </span>
                    </td>
                </tr>
                <tr>
                    <th v-if="language=='fr'">Statut</th>
                    <th v-else>Status</th>
                    <td>  
                        <template v-if="promotion.status!='deleted'">
                            <b-form-checkbox
                                    v-model="promotion.active"
                                    @change="activatePromotion(promotion.id,promotion.active)"
                                    class="custom-control-primary"
                                > <template v-if="promotion.active">
                            
                                <template v-if="language=='fr'">Actif</template><template v-else>Active</template>
                                </template>
                                <template v-else>
                                     <template v-if="language=='fr'">Inactif</template><template v-else>Inactive</template>
                                    
                                </template>
                                    
                            </b-form-checkbox>
                        </template>
                        <span v-else>
                             <template v-if="language=='fr'">Supprimé</template><template v-else>Deleted</template>
                            
                        </span>
                       
                       </td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
            </table>
            <center>
            <b-button
            v-b-modal.modal-danger2 
				
				  variant="outline-dark"
				>
                    <template v-if="language=='fr'">Supprimer</template><template v-else>Delete</template>
				  
				</b-button>
            </center>
        </div>
        <b-modal
          id="modal-danger2"
          cancel-variant="outline-secondary"
          :cancel-title="language=='fr' ? 'Non' : 'No'"
          ok-variant="danger"
          :ok-title="language=='fr' ? 'Oui' : 'Yes'"
          @ok="deletePromo"
          modal-class="modal-danger"
          centered
          :title="language=='fr' ? 'Êtes-vous sûr ?' : 'Are you sure?'"
        >
          <b-card-text v-if="language=='fr'">

            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer cette promotion ?
          </b-card-text>
          <b-card-text v-else>
            Warning, this action is irreversible! Are you sure you want to delete this promotion?
          </b-card-text>
        </b-modal>
    </div>
</template>

<script>
import { BModal,BCardText,BButton,BFormInput, BForm, BRow, BOverlay,BFormDatepicker, BCol, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea,BBadge} from 'bootstrap-vue'

export default {
    name: 'PopupPromotion',
    components: {
        BButton,
        BBadge,
        BModal,
        BFormCheckbox,
        BCardText
    },
    props:['promotion','indexPromo','language'],
    data() {
        return {
            isVisible: false,
            copied: false
        };
    },
    methods: {
        promoCodeLight(code)
        {
            // Find the index of the last occurrence of "-"
            const lastDashIndex = code.lastIndexOf("-");

            // If "-" exists, return the substring before it; otherwise, return the original string
            return lastDashIndex !== -1
            ? code.substring(0, lastDashIndex)
            : code;
        },
        copyCode() {
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 2000);
            navigator.clipboard.writeText(this.promotion.code.toUpperCase());
        },
        activatePromotion(id,active) {
            this.$emit('activatePromotionEv', id,active);
        },
        openPopup() {
            this.isVisible = true;
        },
        closePopup() {
            this.isVisible = false;
        },
        deletePromo() {
            
            this.$emit('deletePromoEvent', this.indexPromo);
            this.closePopup();
        }
        
    }
};
</script>

<style scoped>
@keyframes copied {
    0% { opacity: 1; }
    100% { opacity: 0; }
    
}
.copied
{
    animation:copied 2s linear;
}
.green-patch {
    background: #E2F7E8;
    color: #29C770;
    padding: 5px 20px;
    border-radius: 10px;
    font-size: 22px;
}
.btn
{
    width: 100%;
}
.title-code .cc
{
    cursor: pointer;
    font-size:12px;
}
.title-code {
    text-transform: uppercase;
    display: flex;
    align-items: center;
    margin-right:20px;
    font-size: 38px;
    padding-left:20px;
}
.header-popup {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 20px;
}
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1031;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    position: relative;
}
.close-btn img {
    width:34px;
    height:auto;
}
.cc img {
    width:15px;
    margin-left:5px;
    height:auto;
}
.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
}
@media screen and (max-width: 768px) {
    .popup-content {
        width: 90%;
        padding-top:30px;
    }
    .title-code
    {
        font-size:23px;
    }
    .green-patch
    {
        font-size: 14px;
    }
}
</style>